export let TypeStorage;

(function (TypeStorage) {
  TypeStorage["ReqStorageSet"] = "REQ.STORAGE.SET";
  TypeStorage["ReqStorageGet"] = "REQ.STORAGE.GET";
  TypeStorage["ReqStorageGetAll"] = "REQ.STORAGE.GET_ALL";
  TypeStorage["ReqStorageDelete"] = "REQ.STORAGE.DELETE";
  TypeStorage["ResStorageGet"] = "RES.STORAGE.GET";
  TypeStorage["ResStorageGetAll"] = "RES.STORAGE.GET_ALL";
})(TypeStorage || (TypeStorage = {}));